import AuthWrapper from './auth-wrapper';
import ApolloWrapper from './apollo-wrapper';

export const Wrappers = {
  AuthWrapper,
  ApolloWrapper,
};
